import gql from "graphql-tag";

export const MAKE_COMMENT = gql`
    mutation MakeComment($postId: ID!, $message: String!) {
        makeComment(input: {
            postId: $postId,
            message: $message
        }){
            post{
                id
            }
        }
    }
`;